import cn from 'classnames'

type TProps = {
  value: string
  onChange: (val: string) => void
  onClick: React.MouseEventHandler<HTMLButtonElement>
  label: string
  error?: string
  showValidationErrors?: boolean
  disabled?: boolean
}

const TextBoxReset = ({
  value,
  onChange,
  onClick,
  label,
  error,
  showValidationErrors,
  disabled,
}: TProps) => {
  const onChangeInput = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    onChange(event.target.value)
  }

  return (
    <div className="textbox-reset">
      <input
        value={value}
        disabled={disabled}
        onChange={onChangeInput}
        className={cn('textbox-reset__input', {
          '-error': error && showValidationErrors,
        })}
        type="number"
        placeholder="#"
      />
      <label
        className={cn('textbox-reset__label', {
          '-error': error && showValidationErrors,
        })}
      >
        {label}
      </label>
      <button onClick={onClick} className="textbox-reset__button" type="button" disabled={disabled}>
        Reset
      </button>
    </div>
  )
}

export default TextBoxReset
